const url = (path) => `${process.env.PUBLIC_URL}${path}`;

const categories = [
    {
        slug: "cijfers_en_letters",
        title: "LED Cijfers & Letters",
        tease: "Lichtgevende & NEON cijfers en letters voor elke gelegenheid.",
        image: url("/images/led_verlichting/11.webp"),
        route: "/producten/cijfers_en_letters",
        hero: {
            photo: url("/images-v2/cijfers-en-letters/hero.webp"),
            // Bias toward the upper part of the photo: keeps the marquee letters below
            // the title while still showing the deck/path beneath them.
            position: "center 30%",
        },
        intro:
            "Cijfers & letters zijn de perfecte toevoeging aan uw feest of evenement. Met onze lichtgevende letters of cijfers maakt u in één oogopslag duidelijk hoe oud (of jong) iemand is geworden.",
        sections: [
            {
                heading: "Lichtgevende cijfers & letters",
                text: "Ontdek de veelzijdige mogelijkheden van onze lichtgevende cijfers en letters, waarmee u elke ruimte transformeert met een magische gloed. Perfect voor het creëren van unieke en persoonlijke sferen, dankzij de eindeloze combinaties van cijfers, letters en symbolen.",
                fromPrice: "€29,95",
                priceUnit: "per stuk",
                images: [
                    { src: url("/images-v2/cijfers-en-letters/gallery-1.webp"), alt: "Lichtgevende cijfers '50' in een tuin" },
                    { src: url("/images-v2/cijfers-en-letters/gallery-2.webp"), alt: "Lichtgevende letters 'BOY' in een tuin" },
                    { src: url("/images-v2/cijfers-en-letters/gallery-3.webp"), alt: "Lichtgevend hartsymbool in een tuin" },
                ],
            },
            {
                heading: "NEON-cijfers",
                text: "Ontdek de veelzijdige mogelijkheden van onze NEON-cijfers, waarmee u elke ruimte kunt transformeren. Perfect voor unieke en persoonlijke sferen, dankzij de eindeloze kleurcombinaties.",
                fromPrice: "€34,95",
                priceUnit: "per stuk",
                images: [
                    { src: url("/images/led_verlichting/11.webp"), alt: "NEON cijfer 1" },
                    { src: url("/images/led_verlichting/12.webp"), alt: "NEON cijfer 2" },
                    { src: url("/images/led_verlichting/13.webp"), alt: "NEON cijfer 3" },
                ],
            },
        ],
    },
    {
        slug: "verlichting",
        title: "Verlichting",
        tease: "Sfeervolle LED-bars die elke ruimte in één klap transformeren.",
        image: url("/images/verlichting/IMG_4983.webp"),
        route: "/producten/verlichting",
        hero: {
            photo: url("/images/verlichting/IMG_4983.webp"),
        },
        intro:
            "Verlichting is een essentieel onderdeel van elk succesvol feest of evenement. Op dit moment bieden wij exclusief onze populaire LED-Bars aan — \"Light up the vibe\" is het motto dat daar perfect bij past.",
        sections: [
            {
                heading: "LED-Bars",
                text: "Met hun strakke design en instelbare kleuren creëren onze LED-Bars moeiteloos de juiste ambiance voor elke ruimte. Of u nu kiest voor warme, sfeervolle tinten of opvallende kleuren die de energie verhogen — onze LED-Bars zorgen voor een unieke uitstraling waar uw gasten nog lang over napraten.",
                fromPrice: "€14,95",
                priceUnit: "per stuk",
                images: [
                    { src: url("/images/verlichting/IMG_4927.webp"), alt: "LED-Bar 1" },
                    { src: url("/images/verlichting/IMG_4949.webp"), alt: "LED-Bar 2" },
                    { src: url("/images/verlichting/IMG_4969.webp"), alt: "LED-Bar 3" },
                ],
            },
        ],
    },
    {
        slug: "ballondecoratie",
        title: "Ballondecoratie",
        tease: "Op maat gemaakte ballondecoratie in elke kleur en stijl.",
        image: url("/images/main.webp"),
        route: "/producten/ballondecoratie",
        hero: {
            photo: url("/images-v2/ballondecoratie/hero.webp"),
        },
        features: [
            {
                image: url("/images-v2/ballondecoratie/feature-1.webp"),
                eyebrow: "Op maat",
                title: "Ballondecoratie in elke kleur en stijl",
                text: "Van subtiele pastelslingers tot een metershoge ballonboog als blikvanger — wij ontwerpen uw ballondecoratie volledig op maat. Samen kiezen we de kleuren en stijl die naadloos aansluiten bij uw feest, zodat alles klopt vanaf het moment dat uw gasten binnenkomen.\n\nOf het nu gaat om een verjaardag, jubileum of bedrijfsfeest — wij verzorgen het ontwerp, de opbouw en de afwerking.",
                pullQuote: "Volledig op maat, tot in elk detail.",
            },
            {
                image: url("/images-v2/ballondecoratie/feature-2.webp"),
                eyebrow: "Blikvanger",
                title: "Een achtergrond die alle ogen trekt",
                text: "Combineer uw ballondecoratie met een sfeervolle achtergrond — van een glinsterende paillettenwand tot ballonbogen rondom de entree. Zo wordt het geheel één fotogenieke blikvanger waar uw gasten met plezier op de foto gaan.",
                reverse: true,
            },
        ],
    },
    {
        slug: "photobooth",
        title: "Photobooth",
        tease: "Tastbare herinneringen voor uw gasten.",
        image: url("/images-v2/photobooth/card.webp"),
        route: "/producten/photobooth",
        hero: {
            photo: url("/images-v2/photobooth/hero.webp"),
        },
        intro:
            "Een photobooth is ideaal om uw feest succesvol en memorabel te maken. Het geeft uw gasten ook nog eens een uniek cadeau: een tastbare herinnering aan een fantastisch evenement.",
        sections: [
            {
                heading: "Onbeperkt foto's en boomerangs",
                text: "Leg bijzondere momenten vast met onbeperkte foto's en boomerangs — allemaal met slechts één tik op het scherm. De boomerangs kunnen zelfs worden omgetoverd tot GIF's. Al uw herinneringen worden binnen 14 dagen na het evenement rechtstreeks naar uw inbox gestuurd.",
                images: [
                    { src: url("/images-v2/photobooth/1.webp"), alt: "Gasten poseren met props bij de photobooth" },
                    { src: url("/images-v2/photobooth/2.webp"), alt: "LED-ringlamp photobooth bij het zwembad" },
                    { src: url("/images-v2/photobooth/3.webp"), alt: "Doos met feestprops naast de photobooth" },
                ],
            },
            {
                heading: "Met directe prints",
                text: "Kiest u voor een photobooth met prints? Dan hoeven uw gasten niet 14 dagen te wachten — de foto's worden direct uitgeprint, zodat uw gasten een fysieke herinnering hebben aan uw feest. Het design (kleuren, tekst, layout) wordt vooraf met u afgestemd. Geen extra kosten.",
                fromPrice: "€329,95",
                images: [],
            },
        ],
    },
    {
        slug: "dansvloer",
        title: "LED-Dansvloer",
        tease: "Dance the night away — dé sfeermaker van het feest.",
        image: url("/images-v2/dansvloer/hero.webp"),
        route: "/producten/dansvloer",
        hero: {
            photo: url("/images-v2/dansvloer/hero-banner.webp"),
        },
        intro:
            "Onze LED-Dansvloer is de perfecte toevoeging om uw feest tot een succes te maken. \"Dance the night away\" is het motto dat precies bij onze LED-Dansvloer past — gegarandeerd dat uw gasten aan het einde van de avond de dansvloer niet onaangeraakt achter zullen laten.",
        sections: [
            {
                heading: "Beschikbaar in drie maten",
                text: "Maat 1 — 3×3m (circa 100 gasten)\nMaat 2 — 3×4m (circa 150 gasten)\nMaat 3 — 4×4m (circa 200 gasten)",
                fromPrice: "€379,95",
                images: [
                    { src: url("/images/dansvloer/2.webp"), alt: "LED-Dansvloer 1" },
                    { src: url("/images/dansvloer/3.webp"), alt: "LED-Dansvloer 2" },
                    { src: url("/images/dansvloer/4.webp"), alt: "LED-Dansvloer 3" },
                ],
            },
        ],
        notice:
            "Onze LED-Dansvloer plaatsen wij alleen wanneer wij er zeker van zijn dat de dansvloer overdekt gelegd kan worden. Daarnaast moet de ondergrond vlak zijn. Wij vragen vooraf om een foto van de plaats waar de dansvloer geplaatst zal worden.",
    },
];

export default categories;
